import { unloadClients } from './clients/action'
import { unloadClientPlans } from './plans/action'
import { unloadAdvisorDrawDown } from './drawdown/action'

export const unloadAdvisorData = () => dispatch => {
  dispatch(unloadClients())
  dispatch(unloadClientPlans())
  dispatch(unloadAdvisorDrawDown())
}
